import React, { useState } from "react";
import { Stack } from "@mui/material";
import {
  Container,
  InputLabel,
  InputTextField,
  Instruction,
  SendOtpButton,
  Title,
} from "./forgotPassword.components";
import { useAlert } from "react-alert";
import { useNavigate } from "react-router-dom";
import { homepage, verifyOtpLink } from "../../../common/routes";
import { forgotPassword } from "../../../services/auth";
import { useCookies } from "react-cookie";

function ForgotPassword() {
  const alert = useAlert();
  const navigate = useNavigate();
  const [cookies] = useCookies();
  const [emailID, setEmailID] = useState("");
  const [loader, setLoader] = useState(false);

  if (cookies.token !== undefined && cookies.token !== "undefined")
    navigate(homepage);

  const handleSendOtp = async () => {
    setLoader(true);
    const emailRegex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;
    if (!emailID || !emailRegex.test(emailID)) {
      alert.error("please enter a valid email id");
      return false;
    }

    await forgotPassword({ emailID: emailID })
      .then((response) => {
        if (response.status !== 200) {
          alert.error(response.data.message);
          return;
        }
        setLoader(false);
        alert.success(response.data.message);
        navigate(verifyOtpLink, { state: { emailID: emailID } });
      })
      .catch((error) => console.log(error));
  };

  return (
    <Container>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="flex-start"
        spacing={2.5}
        sx={{ py: 5.75, width: 480, m: "auto" }}
      >
        <Title>Reset Password</Title>
        <Instruction>Enter the registered mail id</Instruction>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
          spacing={2}
        >
          <InputLabel>Email ID</InputLabel>
          <InputTextField
            required
            value={emailID}
            onChange={(e) => setEmailID(e.target.value)}
            type="email"
          />
        </Stack>
        <SendOtpButton loading={loader} onClick={handleSendOtp}>
          Send OTP
        </SendOtpButton>
      </Stack>
    </Container>
  );
}

export default ForgotPassword;
